export class StandardComment {
    code: string;
    value: string;
    show?:boolean = false;
}
